import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  footer: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2)
  },
  list: {
    margin: theme.spacing(0.5)
  },
  footerTitle: {
    display: 'flex'
  },
  goalTitle: {
    fontWeight: 'bold'
  },
  label: {
    paddingLeft: theme.spacing(1)
  }
}));
